import SurveyResultsButton from "../UserInput/Buttons/SurveyResultsButton";
import SurveyPageNotFoundContainer from "./SurveyPageNotFoundContainer";

const SurveyResultsNotFound = ({ themeColors, resetAssessment }) => {
    return (
        <SurveyPageNotFoundContainer themeColors={themeColors}>
            {/* Main Content */}
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "auto",
                    width: "520px",
                    maxWidth: "100%",
                }}
            >
                {/* todo: this tailwind is copied from SurveyResults, it's very complex 
            and ideally both should be replaced */}
                <div className="font-semibold text-3xl md:text-5xl leading-[60px] text-white mb-[30px] text-center md:text-justify">
                    Results Not Found
                </div>
                <div className="text-white md:text-[26px] md:leading-[40px] mb-[30px] text-center md:text-justify text-base font-[500]">
                    We couldn't find the survey results you're looking for.
                </div>
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-end",
                    }}
                >
                    <SurveyResultsButton handleOnClick={resetAssessment} themeColors={themeColors}>
                        Reset assessment
                    </SurveyResultsButton>
                </div>
            </div>
        </SurveyPageNotFoundContainer>
    );
};

export default SurveyResultsNotFound;
